<template>
  <div class="review-comment">
    <div class="review-comment__text">
      <span>{{ visibleComment }}</span>
      <button v-if="isLong" type="button" class="review-comment__readmore" @click="toggleExpand">
        {{ $t(expanded ? "website.widgetReview.lblReadLess" : "website.widgetReview.lblReadMore", language) }}
      </button>
    </div>
    <div class="review-comment__translate" v-if="showTranslate && commentTranslated">
      <template v-if="showTranslated">
        <span class="review-comment__muted">{{ $t("website.widgetReview.lblTranslatedByGoogle", language) }}</span>
        <span class="review-comment__muted">·</span>
        <button type="button" class="review-comment__link" @click="toggleTranslate">
          {{ $t("website.widgetReview.lblSeeOriginal", language) }}
        </button>
      </template>
      <button v-else type="button" class="review-comment__link" @click="toggleTranslate">
        {{ $t("website.widgetReview.lblSeeTranslation", language) }}
      </button>
    </div>
  </div>
</template>

<script>
import { isLongComment, truncateComment } from "@helpers/review.helper";

export default {
  props: {
    comment: { type: String, default: "" },
    commentTranslated: { type: String, default: "" },
    showTranslate: { type: Boolean, default: true },
    language: { type: String, default: "" },
  },
  data() {
    return {
      expanded: false,
      showTranslated: false,
    };
  },
  computed: {
    displayedComment() {
      return this.showTranslated ? this.commentTranslated : this.comment;
    },
    isLong() {
      return isLongComment(this.displayedComment);
    },
    visibleComment() {
      if (this.expanded) return this.displayedComment || "";
      return truncateComment(this.displayedComment);
    },
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      this.$nextTick(() => this.$emit("resize"));
    },
    toggleTranslate() {
      this.showTranslated = !this.showTranslated;
      this.$nextTick(() => this.$emit("resize"));
    },
  },
  watch: {
    comment() {
      this.expanded = false;
      this.showTranslated = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.review-comment {
  &__text {
    font-size: var(--review-comment-fs, 14px);
    line-height: 1.5;
    color: var(--review-comment-color, #3c4043);
    white-space: pre-line;
    word-break: break-word;
  }

  &__readmore,
  &__link {
    display: inline;
    padding: 0;
    border: none;
    background: none;
    color: var(--review-link-color, #1a73e8);
    font-size: var(--review-link-fs, var(--review-comment-link-fs, 14px));
    font-family: var(--review-link-family), Tahoma;
    font-weight: var(--review-link-weight, 600);
    font-style: var(--review-link-style, normal);
    text-decoration: var(--review-link-decoration, unset);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  &__readmore {
    margin-left: 4px;
  }

  &__translate {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    font-size: var(--review-comment-link-fs, 14px);
  }

  &__muted {
    color: var(--review-comment-muted, #5f6368);
  }
}
</style>
